/* Fern — Dew Collective's flower concierge (corner widget).
 * Real backend: streaming Lambda with live-catalog tools. The widget fetches
 * the catalog from the theme's JSON view once per session and sends it with
 * each request, streams SSE deltas back, and keeps history in sessionStorage.
 */
(function () {
  var FERN_API = "https://qxopuro7glmkfmqj5j2wzpz5ym0qnozm.lambda-url.us-east-1.on.aws/chat";
  var CATALOG_URL = "/collections/all?view=fern.json";
  var HISTORY_KEY = "fern_history_v1";
  var MAX_HISTORY = 12;

  var css = "\
.fern-pill{position:fixed;right:12px;bottom:var(--fern-bottom,52px);min-height:44px;z-index:70;display:flex;align-items:center;gap:8px;border:0;border-radius:999px;padding:12px 18px;background:#1C1329;color:#FAF7F2;font:700 13px/1 'DM Sans',sans-serif;letter-spacing:.06em;cursor:pointer;box-shadow:0 10px 30px rgba(28,19,41,.45)}\
.fern-pill:hover{background:#2B1B3D}.fern-pill:focus-visible,.fern-panel :focus-visible{outline:2px solid #B9A3E3;outline-offset:3px}\
.fern-panel{position:fixed;right:12px;bottom:52px;z-index:80;width:min(380px,calc(100vw - 24px));height:min(580px,80vh);display:none;flex-direction:column;background:#1C1329;color:#FAF7F2;border:1px solid rgba(185,163,227,.3);border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.5);font-family:'DM Sans','Helvetica Neue',sans-serif}\
.fern-panel.open{display:flex}\
.fern-head{display:flex;align-items:center;gap:10px;padding:13px 16px;border-bottom:1px solid rgba(185,163,227,.25);font-size:13px}\
.fern-dot{width:9px;height:9px;border-radius:50%;background:#8FD694;box-shadow:0 0 8px #8FD694}\
.fern-x{margin-left:auto;min-width:44px;min-height:44px;background:none;border:0;color:#FAF7F2;font-size:18px;cursor:pointer;}\
.fern-log{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;scroll-behavior:smooth}\
.fern-msg{max-width:88%;padding:10px 13px;border-radius:13px;font-size:14px;line-height:1.5;white-space:pre-wrap;overflow-wrap:break-word}\
.fern-msg.f{align-self:flex-start;background:rgba(185,163,227,.14);border:1px solid rgba(185,163,227,.22);border-bottom-left-radius:4px}\
.fern-msg.f b{color:#B9A3E3}\
.fern-msg.f a{color:#B9A3E3;text-decoration:underline}\
.fern-msg.f img.fern-img{display:block;width:200px;max-width:100%;border-radius:10px;margin:8px 0 12px;border:1px solid rgba(185,163,227,.25)}\
.fern-msg.u{align-self:flex-end;background:#FAF7F2;color:#1A1816;border-bottom-right-radius:4px}\
.fern-status{align-self:flex-start;color:rgba(185,163,227,.75);font-size:12px;font-style:italic}\
.fern-chips{display:flex;flex-wrap:wrap;gap:7px;align-self:flex-start;max-width:95%}\
.fern-chips button{border:1px solid rgba(185,163,227,.3);background:transparent;color:#FAF7F2;border-radius:999px;padding:7px 12px;font:500 12px 'DM Sans',sans-serif;cursor:pointer}\
.fern-chips button:hover{background:rgba(185,163,227,.18)}\
.fern-typing{align-self:flex-start;color:#B9A3E3;font-size:18px;letter-spacing:3px;animation:fernpulse 1s infinite}\
@keyframes fernpulse{50%{opacity:.3}}\
.fern-ask{display:flex;gap:8px;padding:12px;border-top:1px solid rgba(185,163,227,.25)}\
.fern-ask input{flex:1;min-width:0;background:rgba(0,0,0,.3);border:1px solid rgba(185,163,227,.3);border-radius:999px;color:#FAF7F2;padding:10px 15px;font:400 14px 'DM Sans',sans-serif;outline-offset:3px}\
.fern-ask input::placeholder{color:#bdb5c5}\
.fern-ask button{border:0;border-radius:999px;padding:10px 18px;background:#B9A3E3;color:#1C1329;font:700 12px 'DM Sans',sans-serif;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}\
.fern-ask button:disabled{opacity:.5;cursor:default}\
@media (max-width:749px){.fern-pill{right:10px;bottom:calc(var(--fern-bottom,14px) + env(safe-area-inset-bottom));padding:10px 14px;font-size:12px;box-shadow:0 6px 18px rgba(28,19,41,.35)}.fern-panel{bottom:0;right:0;width:100vw;height:85vh;border-radius:16px 16px 0 0}}@media (prefers-reduced-motion:reduce){.fern-typing{animation:none}.fern-log{scroll-behavior:auto}}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  var pill = document.createElement("button");
  pill.className = "fern-pill";
  pill.type = "button";
  pill.textContent = "Ask Fern 🌿";
  pill.setAttribute("aria-expanded", "false");
  pill.setAttribute("aria-controls", "fern-panel");
  pill.setAttribute("aria-label", "Ask Fern, the shop concierge");
  document.body.appendChild(pill);

  var panel = document.createElement("div");
  panel.className = "fern-panel";
  panel.id = "fern-panel";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-labelledby", "fern-title");
  panel.innerHTML =
    "<div class='fern-head'><span class='fern-dot'></span><b id='fern-title'>Fern</b>&nbsp;· Dew Collective concierge<button type='button' class='fern-x' aria-label='Close Fern'>×</button></div>" +
    "<div class='fern-log' role='log' aria-label='Conversation with Fern' aria-live='polite' aria-relevant='additions' aria-atomic='false'></div>" +
    "<form class='fern-ask'><input type='text' placeholder='Ask about flowers, delivery, pickup…' aria-label='Message Fern'><button type='submit'>Send</button></form>";
  document.body.appendChild(panel);

  var log = panel.querySelector(".fern-log");
  var form = panel.querySelector(".fern-ask");
  var input = panel.querySelector("input");
  var sendBtn = form.querySelector("button");

  // ---- history ----
  var history = [];
  try {
    history = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || "[]");
  } catch (e) { history = []; }
  function saveHistory() {
    try { sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(-MAX_HISTORY))); } catch (e) {}
  }

  // ---- catalog (fetched once, cached for the page) ----
  var catalogPromise = null;
  function getCatalog() {
    if (!catalogPromise) {
      catalogPromise = fetch(CATALOG_URL)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    return catalogPromise;
  }

  // ---- rendering ----
  function safeUrl(value, image) {
    if (/[\\\u0000-\u0020]/.test(value)) return null;
    try {
      var url = new URL(value, window.location.origin);
      if (url.username || url.password) return null;
      if (!image) {
        return value.charAt(0) === "/" && value.charAt(1) !== "/" && url.origin === window.location.origin ? url.href : null;
      }
      if (url.protocol !== "https:") return null;
      if (url.hostname === "cdn.shopify.com") return url.href;
      if (url.pathname.indexOf("/cdn/") === 0 &&
          (url.origin === window.location.origin || /^[a-z0-9-]+\.myshopify\.com$/.test(url.hostname))) return url.href;
    } catch (e) {}
    return null;
  }
  function renderMarkdown(target, text) {
    var fragment = document.createDocumentFragment();
    var tokens = /!\[([^\]]*)\]\(([^)\s]*)\)|\[([^\]]+)\]\(([^)\s]*)\)|\*\*([^*]+)\*\*/g;
    var cursor = 0;
    var match;
    while ((match = tokens.exec(text))) {
      fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
      var node;
      var url;
      if (match[1] !== undefined) {
        url = safeUrl(match[2], true);
        if (url) {
          node = document.createElement("img");
          node.className = "fern-img";
          node.src = url;
          node.alt = match[1];
          node.loading = "lazy";
        } else node = document.createTextNode(match[1]);
      } else if (match[3] !== undefined) {
        url = safeUrl(match[4], false);
        node = document.createElement(url ? "a" : "span");
        if (url) node.href = url;
        node.textContent = match[3];
      } else {
        node = document.createElement("b");
        node.textContent = match[5];
      }
      fragment.appendChild(node);
      cursor = tokens.lastIndex;
      if (match[1] !== undefined && url) {
        // Block images already have spacing; don't also render Markdown blank lines below them.
        var spacing = /^[ \t]*(?:\r?\n[ \t]*)+/.exec(text.slice(cursor));
        if (spacing) { cursor += spacing[0].length; tokens.lastIndex = cursor; }
      }
    }
    fragment.appendChild(document.createTextNode(text.slice(cursor)));
    target.replaceChildren(fragment);
  }
  function addMsg(cls, text) {
    var el = document.createElement("div");
    el.className = "fern-msg " + cls;
    if (cls === "f") renderMarkdown(el, text); else el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }
  function addStatus(text) {
    var el = document.createElement("div");
    el.className = "fern-status";
    el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }
  var TOOL_LABELS = {
    search_products: "checking the cooler…",
    check_delivery: "checking delivery…",
    build_cart_link: "getting your cart ready…",
  };

  function greet() {
    if (log.children.length > 0) return;
    if (history.length > 0) {
      for (var i = 0; i < history.length; i++) {
        addMsg(history[i].role === "user" ? "u" : "f", history[i].content);
      }
      return;
    }
    addMsg("f", "Hi, I'm Fern 🌿 — the shop's flower concierge. Tell me the occasion, your budget, or the town it's going to, and I'll find the right thing.");
    var chips = document.createElement("div");
    chips.className = "fern-chips";
    ["What's fresh this week?", "Sympathy flowers", "Do you deliver to Portsmouth?", "Something around $125"].forEach(function (t) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = t;
      b.addEventListener("click", function () { chips.remove(); send(t); });
      chips.appendChild(b);
    });
    log.appendChild(chips);
  }

  // ---- send / stream ----
  var streaming = false;
  function send(text) {
    if (streaming || !text.trim()) return;
    streaming = true;
    log.setAttribute("aria-busy", "true");
    sendBtn.disabled = true;
    addMsg("u", text);
    history.push({ role: "user", content: text });
    saveHistory();

    var typing = document.createElement("div");
    typing.className = "fern-typing";
    typing.textContent = "•••";
    log.appendChild(typing);
    log.scrollTop = log.scrollHeight;

    var wakeStatus = null;
    var wakeTimer = setTimeout(function () {
      wakeStatus = addStatus("Fern is waking up…");
    }, 2500);
    function clearWakeStatus() {
      clearTimeout(wakeTimer);
      if (wakeStatus) { wakeStatus.remove(); wakeStatus = null; }
    }

    var fernEl = null;
    var fernText = "";
    var statusEl = null;

    function applyEvent(ev) {
      clearWakeStatus();
      if (ev.type === "text_delta") {
        if (statusEl) { statusEl.remove(); statusEl = null; }
        if (!fernEl) { typing.remove(); fernEl = addMsg("f", ""); }
        fernText += ev.text;
        renderMarkdown(fernEl, fernText);
        log.scrollTop = log.scrollHeight;
      } else if (ev.type === "tool_use") {
        if (statusEl) statusEl.remove();
        statusEl = addStatus(TOOL_LABELS[ev.name] || "looking that up…");
        if (fernText && !/\s$/.test(fernText)) {
          fernText += "\n\n";
          if (fernEl) renderMarkdown(fernEl, fernText);
        }
      } else if (ev.type === "error") {
        typing.remove();
        if (statusEl) { statusEl.remove(); statusEl = null; }
        addMsg("f", ev.message || "Something went wrong — try again?");
      }
    }

    function attempt(n) {
      return getCatalog().then(function (catalog) {
        return fetch(FERN_API, {
          method: "POST",
          headers: { "content-type": "application/json", accept: "text/event-stream" },
          body: JSON.stringify({ messages: history.slice(-MAX_HISTORY), catalog: catalog }),
        });
      }).then(function (resp) {
        if (!resp.ok && [502, 503, 504].indexOf(resp.status) >= 0 && n < 2) {
          return new Promise(function (res) { setTimeout(res, 700 * (n + 1) * (n + 1)); }).then(function () {
            return attempt(n + 1);
          });
        }
        return resp;
      });
    }

    attempt(0)
      .then(function (resp) {
        if (!resp.ok || !resp.body) throw new Error("http " + resp.status);
        var reader = resp.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return;
            buffer += decoder.decode(r.value, { stream: true });
            var parts = buffer.split("\n\n");
            buffer = parts.pop() || "";
            for (var i = 0; i < parts.length; i++) {
              var line = parts[i].trim();
              if (line.indexOf("data: ") !== 0) continue;
              try { applyEvent(JSON.parse(line.slice(6))); } catch (e) {}
            }
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (fernText) {
          history.push({ role: "assistant", content: fernText });
          saveHistory();
        } else if (!statusEl) {
          typing.remove();
        }
      })
      .catch(function () {
        typing.remove();
        addMsg("f", "I couldn't reach the shop just now — mind trying again in a moment? You can also call us at (603) 206-5959.");
      })
      .then(function () {
        clearWakeStatus();
        typing.remove();
        if (statusEl) statusEl.remove();
        streaming = false;
        sendBtn.disabled = false;
        log.setAttribute("aria-busy", "false");
      });
  }

  // ---- wiring ----
  var OPEN_KEY = "fern_open_v1";
  function openPanel(focus) {
    panel.classList.add("open");
    pill.setAttribute("aria-expanded", "true");
    pill.style.display = "none";
    try { sessionStorage.setItem(OPEN_KEY, "1"); } catch (e) {}
    greet();
    if (focus) input.focus();
  }
  pill.addEventListener("click", function () { openPanel(true); });
  function closePanel() {
    panel.classList.remove("open");
    pill.style.display = "flex";
    pill.setAttribute("aria-expanded", "false");
    try { sessionStorage.removeItem(OPEN_KEY); } catch (e) {}
    positionPill();
    pill.focus();
  }
  panel.querySelector(".fern-x").addEventListener("click", closePanel);
  panel.addEventListener("keydown", function (event) {
    if (event.key === "Escape") { event.preventDefault(); closePanel(); }
  });

  function positionPill() {
    if (panel.classList.contains("open")) return;
    var mobile = window.matchMedia("(max-width:749px)").matches;
    var bottom = mobile ? 14 : 52;
    var width = pill.offsetWidth;
    var height = pill.offsetHeight;
    var edge = mobile ? 10 : 12;
    var right = window.innerWidth - edge;
    var left = right - width;
    var viewportHeight = window.innerHeight;
    var controls = Array.from(document.querySelectorAll(
      '.dew-footer a, .dew-footer__col-title, .dew-footer__bottom, .dew-footer__credit, .field__input, .contact-form__input, .product-form-buttons, .sticky-add-to-cart, .shopify-payment-button, .dew-btn, button[name="checkout"]'
    )).map(function (el) { return el.getBoundingClientRect(); })
      .filter(function (r) { return r.width && r.height && r.bottom > 0 && r.top < viewportHeight; })
      .sort(function (a, b) { return b.top - a.top; });
    function intersects(r, l, rr) {
      return r.right > l - 12 && r.left < rr + 12 && r.bottom > viewportHeight - bottom - height - 12 && r.top < viewportHeight - bottom + 12;
    }
    var useLeft = !mobile && controls.some(function (r) { return intersects(r, left, right); }) &&
      !controls.some(function (r) { return intersects(r, edge, edge + width); });
    pill.style.left = useLeft ? edge + "px" : "auto";
    pill.style.right = useLeft ? "auto" : edge + "px";
    if (useLeft) { left = edge; right = edge + width; }
    controls.forEach(function (r) {
      if (intersects(r, left, right)) bottom = viewportHeight - r.top + 12;
    });
    pill.style.setProperty("--fern-bottom", Math.min(bottom, viewportHeight - height - 12) + "px");
  }
  var positionFrame = null;
  function schedulePosition() {
    if (positionFrame !== null) return;
    positionFrame = requestAnimationFrame(function () { positionFrame = null; positionPill(); });
  }
  window.addEventListener("scroll", schedulePosition, { passive: true });
  window.addEventListener("resize", schedulePosition);
  if (window.visualViewport) window.visualViewport.addEventListener("resize", schedulePosition);
  if (window.ResizeObserver) new ResizeObserver(schedulePosition).observe(document.body);
  schedulePosition();
  // Stay open across page navigations within the session.
  try {
    if (sessionStorage.getItem(OPEN_KEY) === "1") openPanel(false);
  } catch (e) {}
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var t = input.value;
    input.value = "";
    send(t);
  });
})();
